// Shared stable per-bubble id generator. Used as the primary key on the
// backend feedback row and as the React key for reaction lookup, so every
// AI bubble on both the desktop ChatDrawer and the mobile /m/q surface
// needs to route through this helper. Collision probability is irrelevant
// at this volume — a UUID (or a Date+random fallback) is stable enough
// for the bubble's lifetime in the customer's own feedback table.
export function makeMessageId(): string {
    try {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
            return crypto.randomUUID();
        }
    } catch { /* fallthrough */ }
    return `m_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}
